<div
  class="flex flex-col items-center justify-center bg-app-background h-screen overflow-y-auto mib-scrollbar min-h-0"
>
  <div
    class="flex-1 flex flex-col gap-16 max-lg:landscape:gap-4 [@media(max-height:500px)]:gap-4 items-center justify-center"
  >
    <mai-mib-logo
      size="large"
      stayLarge
      class="transition-all duration-150 max-lg:landscape:absolute max-lg:landscape:top-4 max-lg:landscape:left-4 [@media(max-height:600px)]:absolute [@media(max-height:600px)]:top-4 [@media(max-height:600px)]:left-4"
    ></mai-mib-logo>
    <div class="flex flex-col gap-5.5 text-center">
      <h2 class="text-3xl text-branding-primary">Login Medinbox AI Live</h2>
      <p>Enter your details below to login.</p>
    </div>

    <form class="flex flex-col gap-2 w-full" [formGroup]="formGroup" (submit)="onSubmit()">
      @if (authError()) {
        <div
          class="bg-red-100 border border-input-error text-input-error px-3 py-2 rounded-sm mb-2"
        >
          {{ authError() }}
        </div>
      }
      <div class="relative flex flex-col gap-1 w-full text-sm">
        <label for="username" class="text-gray-500 w-full"
          >Username <span class="text-red-700">*</span></label
        >
        <input
          class="mib-input"
          formControlName="username"
          name="username"
          type="text"
          autocomplete="username"
          [class.mib-field-error]="submitted() && username?.invalid"
          tabindex="1"
          required
        />
        @if (submitted() && username?.hasError('required')) {
          <div class="text-input-error">Username is required</div>
        }
      </div>
      <div class="relative flex flex-col gap-1 w-full text-sm">
        <label for="password" class="text-gray-500 w-full"
          >Password <span class="text-red-700">*</span></label
        >
        <input
          class="mib-input"
          formControlName="password"
          name="password"
          type="password"
          autocomplete="current-password"
          [class.mib-field-error]="submitted() && password?.invalid"
          required
        />
        @if (submitted() && password?.hasError('required')) {
          <div class="text-input-error">Password is required</div>
        }
      </div>
      <mib-button
        type="submit"
        class="w-full mt-14 max-lg:landscape:mt-2 [@media(max-height:500px)]:mt-4"
        [disabled]="formGroup.invalid || loading()"
        >Login</mib-button
      >
    </form>
  </div>

  <mai-copyright-and-legal-link
    class="py-4 md:py-8 max-lg:landscape:pt-2 max-lg:landscape:pb-4"
  ></mai-copyright-and-legal-link>
</div>
